<template>
  <div class="changer-locale-container">
    <img
      src="/assets/imgs/es.png"
      alt="Español"
      class="flag-icon mr-2"
      :class="{ 'inactive': $i18n.locale !== 'es' }"
      @click="setLocale('es')"
    />
    <img
      src="/assets/imgs/en.png"
      alt="English"
      class="flag-icon"
      :class="{ 'inactive': $i18n.locale !== 'en' }"
      @click="setLocale('en')"
    />
  </div>
</template>

<script>
export default {
  methods: {
    setLocale(lang) {
      this.$i18n.locale = lang;
    }
  }
}
</script>

<style lang="scss" scoped>
.changer-locale-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;  
}

.flag-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  object-fit: contain;
  transition: all 0.3s ease;
  border-radius: 50%;
  
  &.inactive {
    opacity: 0.4;
    filter: grayscale(20%);
  }

  &:hover {
    opacity: 1;
    filter: grayscale(0%);
    transform: scale(1.1);
  }
}
</style>
